package com.evoapps.evoshift.data.dto.roster

import com.evoapps.evoshift.domain.model.ShiftManagerNotes
import kotlinx.serialization.Serializable

/**
 * SH-259: `shift_manager_notes/{shiftId}`, the managers' notes on a shift (firestore.rules:
 * the workplace's managers and owner only; functions/shiftManagerNotes.js).
 */
@Serializable
data class ShiftManagerNotesDto(
    val shiftId: String,
    val rosterId: String,
    val noShowReason: String? = null,
    val splitReason: String? = null,
    val updatedAt: String = "",
    val updatedBy: String = ""
) {
    fun toDomain(): ShiftManagerNotes = ShiftManagerNotes(shiftId, rosterId, noShowReason, splitReason)

    companion object {
        fun of(notes: ShiftManagerNotes, updatedAt: String, updatedBy: String): ShiftManagerNotesDto =
            ShiftManagerNotesDto(notes.shiftId, notes.rosterId, notes.noShowReason, notes.splitReason, updatedAt, updatedBy)
    }
}
